import { schAdjustTermKey, schToolkitStudyV1 } from '@aloft/toolkit-shared';

import { z } from 'zod';

import { useZodForm } from '../../../hooks/useZodForm.js';
import { selectMLSIDs } from '../../../redux/features/selectors/accountSelectors.js';
import { useAppSelector } from '../../../redux/hooks.js';

const schBase = schToolkitStudyV1.pick({
  mlsID: true,
  propertyType: true,
});

export const schCreateStudy = schBase
  .merge(
    z.object({
      analysisFeature: schAdjustTermKey,
    }),
  )
  .or(
    schBase.merge(
      z.object({
        analysisFeature: z.literal('custom'),
        customAnalysisFeatureName: z.string().min(1),
      }),
    ),
  );

export type AddStudy = z.infer<typeof schCreateStudy>;

export function useAddStudyForm({ onSubmit }: { onSubmit: (req: AddStudy) => void }) {
  const mlsIDs = useAppSelector(selectMLSIDs);

  // FIXME: use order level mlsIDs before global user mlsIDs before ''

  const defaultValues: Partial<AddStudy> = {
    mlsID: mlsIDs[0] ?? '',
    propertyType: 'singleFamilyResidence',
    customAnalysisFeatureName: '', // needed to fix uncontrolled to controlled error
  };

  const {
    watch,
    control,
    setValue,
    formState,
    resetField,
    reset,
    setError,
    clearErrors,
    handleSubmit: useFormHandleSubmit,
  } = useZodForm({
    schema: schCreateStudy,
    defaultValues: defaultValues,
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const handleSubmit = useFormHandleSubmit(
    (payload: AddStudy) => onSubmit(payload),
    (payload) => console.warn(payload),
  );

  return {
    control,
    formState,
    resetField,
    reset,
    handleSubmit,
    setValue,
    watch,
    setError,
    clearErrors,
  };
}
